import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import DisclaimerModal from "./components/DisclaimerModal";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Accuracy from "./pages/Accuracy";
import Portfolio from "./pages/Portfolio";
import Learn from "./pages/Learn";
import Methodology from "./pages/Methodology";
import About from "./pages/About";
import Search_ from "./pages/Search";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
      <Route path="/track-record" element={<Layout><Accuracy /></Layout>} />
      <Route path="/methodology" element={<Layout><Methodology /></Layout>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/search" element={<Protected><Layout><Search_ /></Layout></Protected>} />
      <Route path="/portfolio" element={<Protected><Layout><Portfolio /></Layout></Protected>} />
      <Route path="/learn" element={<Protected><Layout><Learn /></Layout></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <DisclaimerModal />
          <AppRouter />
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
